import './style-index.css'; // Importeer de hoofd CSS-stijl voor het blok
import { registerBlockType } from '@wordpress/blocks'; // Functie om een Gutenberg-blok te registreren
import { ReactComponent as SeoNinjaIcon } from '../../../admin/images/seoninja.svg'; // Importeer de SVG-icoon voor het blok
import Edit from './edit'; // Importeer de bewerkingscomponent voor de Gutenberg editor
import Save from './save'; // Importeer de opslagcomponent voor de front-end weergave (voor statische blokken)
import metadata from './block.json'; // Importeer de metadata van het blok

// Registreer het Gutenberg-blok met de opgegeven naam en configuratie.
registerBlockType( metadata.name, {
  icon: SeoNinjaIcon, // Stel het blokicoon in
  edit: Edit, // Koppel de bewerkingscomponent aan het blok
  save: Save, // Koppel de opslagcomponent aan het blok
} );

// Wacht tot de DOM volledig is geladen voordat het script wordt uitgevoerd.
// Dit gedeelte dient als client-side fallback/verbetering mocht de server-side rendering niet werken of
// als de content dynamisch (opnieuw) geladen moet worden.
document.addEventListener( 'DOMContentLoaded', () => {
  // Controleer of wpApiSettings bestaat en de REST API root-URL beschikbaar is.
  // Dit is cruciaal voor het ophalen van data van de WordPress REST API.
  if (typeof window.wpApiSettings === 'undefined' || !window.wpApiSettings.root) {
    // Toon een waarschuwing in de console als de API-instellingen ontbreken.
    console.warn('wpApiSettings niet gevonden – FAQ block kan geen data laden.');
    return; // Stop de uitvoering als de instellingen ontbreken.
  }

  // Selecteer alle elementen met de klassen '.wp-block-seoninja-faqs-list' of '.seoninja-faqs-list'.
  // Dit zijn de containers waar de FAQ's in geladen moeten worden.
  const blocks = document.querySelectorAll('.wp-block-seoninja-faqs-list, .seoninja-faqs-list');
  if (!blocks.length) return; // Stop als er geen blokken gevonden zijn.

  // Normaliseer de REST API root-URL door eventuele trailing slashes te verwijderen en er één toe te voegen.
  const root = window.wpApiSettings.root.replace(/\/$/, '') + '/';
  
  // Loop door elk gevonden blok om de FAQ's te laden en weer te geven.
  blocks.forEach( ( block ) => {
    // === NIEUWE LOGICA VOOR REKENING HOUDEN MET RENDER.PHP ===
    // Als render.php de FAQs al heeft geladen, zullen er <details> elementen in het blok zijn.
    // In dat geval is het niet nodig om de FAQs opnieuw client-side op te halen.
    // De initiële <p>Loading FAQs...</p> van de editor verdwijnt dan vanzelf.
    if (block.querySelector('details')) {
      console.log('FAQs al geladen door render.php, client-side fetch overgeslagen voor dit blok.');
      return; // Sla de rest van de client-side logica over voor dit blok.
    }
    // === EINDE NIEUWE LOGICA ===

    // Haal de 'data-limit' attribuutwaarde op, of gebruik 10 als standaard.
    const limit = block.getAttribute( 'data-limit' ) || 10;
    // Construeer de URL voor de custom FAQ's REST API-endpoint.
    const url   = `${ root }seoninja/v1/faqs?limit=${ encodeURIComponent( limit ) }`;

    // Voer de fetch-aanroep uit om de FAQ-data op te halen.
    fetch( url )
      .then( ( res ) => res.json() ) // Converteer de respons naar JSON.
      .then( ( faqs ) => {
        block.innerHTML = ''; // Maak de inhoud van het blok leeg voordat nieuwe FAQ's worden toegevoegd.
        
        // Controleer of de ontvangen data een array is en of deze niet leeg is.
        if ( ! Array.isArray( faqs ) || faqs.length === 0 ) {
          block.textContent = 'Geen FAQs gevonden.'; // Toon een bericht als er geen FAQ's zijn.
          return;
        }

        // Loop door elke FAQ en genereer de HTML-structuur.
        faqs.forEach( ( faq ) => {
          console.log(faq);
          const details = document.createElement( 'details' ); // Maak een <details> element aan
          const summary = document.createElement( 'summary' ); // Maak een <summary> element aan
          summary.textContent = faq.title; // Stel de titel van de FAQ in

          const content = document.createElement( 'div' ); // Maak een div aan om de FAQ-inhoud en link te bevatten

          // Maak een wrapper div voor de FAQ-inhoud om te zorgen dat de link eronder komt te staan.
          const faqContentWrapper = document.createElement('div'); 
          faqContentWrapper.innerHTML = faq.content; // Plaats de FAQ-inhoud in de wrapper.
          content.append(faqContentWrapper); // Voeg de wrapper toe aan de hoofdcontent-div.

          const hyperlink = document.createElement( 'a' ); // Maak een hyperlink element aan
          hyperlink.textContent = 'Lees meer'; // Stel de tekst van de hyperlink in
          hyperlink.href = faq.link; // Stel de URL van de hyperlink in

          content.append(hyperlink); // Voeg de hyperlink toe aan de hoofdcontent-div, na de FAQ-inhoud.

          details.append( summary, content ); // Voeg de summary en de content-div toe aan het details-element.
          block.appendChild( details ); // Voeg het complete details-element toe aan het blok.
        } );
      } )
      .catch( (error) => {
        // Vang eventuele fouten tijdens het fetchen en log deze.
        console.error('Fout bij ophalen FAQs:', error); 
        block.textContent = 'Kan FAQs niet ophalen.'; // Toon een foutbericht aan de gebruiker.
      } );
  } );
} );
